module.exports = "kendo-datepicker.range-filter, .range-seperator {\n  display: inline-block; }\n\n.range-seperator {\n  line-height: 38px;\n  -ms-flex: inherit;\n      flex: inherit;\n  -webkit-box-flex: inherit;\n  padding: 0 5px; }\n\n.k-button {\n  margin-left: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/filters/row/date-range/date-range.component.scss
// module id = ./libs/chassis-datatable/src/components/filters/row/date-range/date-range.component.scss
// module chunks = main